import { render, staticRenderFns } from "./RegistroCapacitaciones.vue?vue&type=template&id=6b7f2f89&scoped=true"
import script from "./RegistroCapacitaciones.vue?vue&type=script&lang=js"
export * from "./RegistroCapacitaciones.vue?vue&type=script&lang=js"
import style0 from "./RegistroCapacitaciones.vue?vue&type=style&index=0&id=6b7f2f89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f2f89",
  null
  
)

export default component.exports